import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import LogoBlanco from '../assets/images/logoBlanco.png';
import LogoSecum from "../assets/images/logoSecum.png";
import LogoMichoacan from "../assets/images/logoMariposas.png";
import { GlobalContext } from "../context/global_context";
import MenuIcon from "@mui/icons-material/Menu";
import LogoGuinda from "../assets/images/LogoGuinda.png";
import { FaUserCircle } from "react-icons/fa";
import Carrito from "../componets/ui/carritoDrawer";
import { services } from "../services/api";
import LoaderComponent from "./LoaderComponent";

const HeaderComponent = ({ login, setLogin }) => {
  const navigate = useNavigate();

  const { GlobalState, setGlobalState } = useContext(GlobalContext);
  const logoutInProgress = useRef(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (logoutInProgress.current) return;
    logoutInProgress.current = true;
    setIsLoggingOut(true);

    try {
      await services("POST", "logout", null);
    } catch (error) {
      console.error("Error al cerrar sesión en el servidor:", error);
    } finally {
      localStorage.clear();
      document.cookie = 'app_auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      setLogin(null);
      logoutInProgress.current = false;
      setIsLoggingOut(false);
      navigate("/login");
    }
  };

  return (
    <>
      {isLoggingOut && <LoaderComponent message="Cerrando sesión…" />}
      <div className="header">
        <div className="container h-100  d-none d-lg-block">
          <div
            className={
              login
                ? "d-flex align-items-center h-100"
                : "d-flex justify-content-center align-items-center h-100"
            }
            style={{ justifyContent: "left !important" }}
          >
            {login &&
              localStorage.getItem("rol") === "Admin" ? (
              <div
                className="ms-1 link text-bold text-bigtext--morado"
                onClick={() => {
                  setGlobalState({ ...GlobalState, navBarOpen: true });
                }}
              >
                <MenuIcon />
              </div>
            ) : (
              <></>
            )}
            <div
              className="cursor-pointer"
              onClick={() => {
                navigate("/");
                setGlobalState({ ...GlobalState, path: "/" });
              }}
            >
              <img
                className="logo me-3 "
                src={LogoGuinda}
                alt="Logotipo Culturas"
              />
            </div>
            <div className="ms-3 text-normal text--gray">
              <div className="d-flex align-items-center">
                <img
                  className="logoSecum me-3"
                  src={LogoSecum}
                  alt="Logotipo Culturas"
                />
                <img
                  className="logoMichoacan  ms-3"
                  src={LogoMichoacan}
                  alt="Logotipo Michoacán"
                />
              </div>
            </div>
            {login &&
              localStorage.getItem("rol") === "Admin" ? (
              <></>
            ) : (
              <>

                <div className="col"></div>

                {localStorage.getItem("rol") === "Alumno" ? (
                  <>
                    <div >
                      <Carrito />
                    </div>


                    <div
                      className="link text-bold text--morado"
                      onClick={() => {
                        navigate("/mis-cursos");
                        setGlobalState({ ...GlobalState, path: "/mis-cursos" });
                      }}
                    >
                      MIS CURSOS

                    </div>

                  </>
                )
                  : (
                    <>
                    </>
                  )}

                {localStorage.getItem('rol') === "Profesor" ? (
                  <div
                    className="link text-bold text--morado"
                    onClick={() => {
                      navigate("/mis-talleres");
                      setGlobalState({ ...GlobalState, path: "/mis-talleres" });
                    }}
                  >
                    MIS TALLERES

                  </div>

                ) : (
                  <>
                  </>
                )
                }

                <div
                  className="link text-bold text--morado"
                  onClick={() => {
                    navigate("/talleres");
                    setGlobalState({ ...GlobalState, path: "/talleres" });
                  }}
                >
                  TALLERES
                </div>
                <div
                  className="ms-1 link text-bold text--morado"
                  onClick={() => {
                    navigate("/contacto");
                    setGlobalState({ ...GlobalState, path: "/contacto" });
                    setTimeout(() => {
                      const elemento = document.getElementById("contacto"); // 1. Buscamos el elemento
                      if (elemento) { // 2. SOLO si existe, hacemos el scroll
                        elemento.scrollIntoView({
                          behavior: "smooth",
                        });
                      } else {
                        console.warn("buscando contacto");
                      }
                    }, 500);
                  }}
                >

                  CONTACTO
                </div>

                <div className="ms-1 text-bold text--morado h-100">
                  {localStorage.getItem("rol") === "Alumno" ||
                    localStorage.getItem("rol") === "Profesor" ? (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <div className="dropdown">
                        <button
                          className="btn btn-secondary btn-drop dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <FaUserCircle />
                        </button>
                        <ul className="dropdown-menu">
                          <li className="cursor-pointer">
                            <button
                              className="dropdown-item"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={() => {
                                navigate("/perfil");
                              }}
                            >
                              Perfil
                            </button>
                          </li>
                          <li className="cursor-pointer">
                            <button
                              className="dropdown-item"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={handleLogout}
                            >
                              Cerrar Sesión
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="link h-100"
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      INICIAR SESIÓN
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        <div className="container-fluid h-100 d-none d-lg-none d-md-block ">
          <div
            className={
              login
                ? "d-flex align-items-center h-100"
                : "d-flex justify-content-center align-items-center h-100"
            }
            style={{ justifyContent: "left !important" }}
          >
            {login &&
              localStorage.getItem("rol") === "Admin" ? (
              <div
                className="ms-1 link text-bold text-bigtext--gray"
                onClick={() => {
                  setGlobalState({ ...GlobalState, navBarOpen: true });
                }}
              >
                <MenuIcon />
              </div>
            ) : (
              <></>
            )}
            <div
              className="cursor-pointer"
              onClick={() => {
                navigate("/");
                setGlobalState({ ...GlobalState, path: "/" });
              }}
            >
              <img className="logo" src={LogoGuinda} alt="Logotipo Culturas" />
            </div>
            <div className="ms-3 text-normal text--morado">
              <div className="d-flex align-items-center">
                <img
                  className="logoSecum ms-3"
                  src={LogoSecum}
                  alt="Logotipo Culturas"
                />
                <img
                  className="logoMichoacan  ms-3"
                  src={LogoMichoacan}
                  alt="Logotipo Michoacán"
                />
              </div>
            </div>
            {login &&
              localStorage.getItem("rol") === "Admin" ? (
              <></>
            ) : (
              <>
                <div className="col"></div>
                {localStorage.getItem("rol") === "Alumno" ? (

                  <>
                    <div >
                      <Carrito />
                    </div>


                    <div
                      className="link text-bold text--morado"
                      onClick={() => {
                        navigate("/mis-cursos");
                        setGlobalState({ ...GlobalState, path: "/mis-cursos" });
                      }}
                    >
                      MIS CURSOS

                    </div>

                  </>


                ) : (
                  <></>
                )}

                {localStorage.getItem('rol') === "Profesor" ? (
                  <div
                    className="link text-bold text--morado"
                    onClick={() => {
                      navigate("/mis-talleres");
                      setGlobalState({ ...GlobalState, path: "/mis-talleres" });
                    }}
                  >
                    MIS TALLERES

                  </div>

                ) : (
                  <>
                  </>
                )
                }

                <div
                  className="link text-bold text-mediumtext--morado"
                  onClick={() => {
                    navigate("/talleres");
                    setGlobalState({ ...GlobalState, path: "/talleres" });
                  }}
                >
                  TALLERES
                </div>

                <div
                  className="ms-1 link text-bold text-mediumtext--morado"
                  onClick={() => {
                    navigate("/contacto");
                    setGlobalState({ ...GlobalState, path: "/contacto" });
                    setTimeout(() => {
                      document.getElementById("contacto").scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 500);
                  }}
                >
                  CONTACTO
                </div>






                <div className="ms-1 text-bold text--morado h-100">
                  {localStorage.getItem("rol") === "Alumno" ||
                    localStorage.getItem("rol") === "Profesor" ? (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <div className="dropdown">
                        <button
                          className="btn btn-secondary btn-drop dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <FaUserCircle />
                        </button>
                        <ul className="dropdown-menu">
                          <li className="cursor-pointer">
                            <button
                              className="dropdown-item"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={() => {
                                navigate("/perfil");
                              }}
                            >
                              Perfil
                            </button>
                          </li>
                          <li className="cursor-pointer">
                            <button
                              className="dropdown-item"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={handleLogout}
                            >
                              Cerrar Sesión
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="link h-100"
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      INICIAR SESIÓN
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        <div className="container-fluid h-100  d-lg-none d-md-none d-sm-block">
          <div
            className={
              login
                ? "d-flex align-items-center h-100"
                : "d-flex justify-content-center align-items-center h-100"
            }
            style={{ justifyContent: "left !important" }}
          >
            {login &&
              localStorage.getItem("rol") === "Admin" ? (
              <div
                className="ms-1 link text-bold text-bigtext--morado"
                onClick={() => {
                  setGlobalState({ ...GlobalState, navBarOpen: true });
                }}
              >
                <MenuIcon />
              </div>
            ) : (
              <></>
            )}
            <div
              className="cursor-pointer"
              onClick={() => {
                navigate("/");
                setGlobalState({ ...GlobalState, path: "/" });
              }}
            >
              <img
                className="logo me-3 "
                src={LogoGuinda}
                alt="Logotipo Culturas"
              />
            </div>

            {login &&
              localStorage.getItem("rol") === "Admin" ? (
              <></>
            ) : (
              <>
                <div className="col"></div>
                {localStorage.getItem("rol") === "Alumno" ? (
                  <> <div >
                    <Carrito />
                  </div>

                    <div
                      className="link text-bold text--morado"
                      onClick={() => {
                        navigate("/mis-cursos");
                        setGlobalState({ ...GlobalState, path: "/mis-cursos" });
                      }}
                    >
                      MIS CURSOS

                    </div> </>
                ) : (
                  <></>
                )}

                <div
                  className="link text-bold text-smalltext--morado"
                  onClick={() => {
                    navigate("/talleres");
                    setGlobalState({ ...GlobalState, path: "/talleres" });
                  }}
                >
                  TALLERES
                </div>

                <div
                  className="ms-1 link text-bold text-smalltext--morado"
                  onClick={() => {
                    navigate("/contacto");
                    setGlobalState({ ...GlobalState, path: "/contacto" });
                    setTimeout(() => {
                      document.getElementById("contacto").scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 500);
                  }}
                >
                  CONTACTO
                </div>

                <div className="ms-1 text-bold text--morado h-100">
                  {localStorage.getItem("rol") === "Alumno" ||
                    localStorage.getItem("rol") === "Profesor" ? (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <div className="dropdown">
                        <button
                          className="btn btn-secondary btn-drop dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <FaUserCircle />
                        </button>
                        <ul className="dropdown-menu">
                          <li className="cursor-pointer">
                            <button
                              className="dropdown-item"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={() => {
                                navigate("/perfil");
                              }}
                            >
                              Perfil
                            </button>
                          </li>
                          <li className="cursor-pointer">
                            <button
                              className="dropdown-item"
                              style={{ border: 'none', background: 'transparent' }}
                              onClick={handleLogout}
                            >
                              Cerrar Sesión
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="link h-100"
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      INICIAR SESIÓN
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderComponent;
